<template>
  <div class="human-capitalt-view-past">
    <h2 class="heading-lv2">{{this.disabilitiesRate.year}}年{{this.month}}月期</h2>
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">障がい者雇用数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 50%;">
            <col>
          </colgroup>
          <tbody>
            <tr>
              <th>身体</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="disabilitiesRate.disabledDisabilities" :unit="this.unit"/></span>
              </td>
            </tr>
            <tr>
              <th>知的</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="disabilitiesRate.intellectualDisabilities" :unit="this.unit"/></span>
              </td>
            </tr>
            <tr>
              <th>精神</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="disabilitiesRate.mentallyDisabilities" :unit="this.unit"/></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

      <div class="human-capitalt-data-wrap__space"></div>

      <div class="human-capitalt-data-wrap__results">
        <div class="human-capitalt-data-results">
          <div class="human-capitalt-data-results__text">
            障がい者雇用率
            <strong><Currency :value="disabilitiesRate.achievementDisabilitiesRate"/></strong>%
          </div>
        </div>
      </div>

    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(disabilitiesRate.resultMemo)"></p>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
            </div>
            <div class="l-contentsMemo__body">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(disabilitiesRate.actionMemo)"></p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2 u-mt30-->
  </div><!--/human-capitalt-data-past-->

</template>

<script>
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    Currency,
  },
  props: {
    // 表示年度の財務情報データ
    disabilitiesRate: {},
    month: null,
    num: null,
  },
  data() {
    return {
      unit: '名',
      unit2:'％',
    }
  },
  computed: {
  },
  watch: {
    disabilitiesRate() {
      this.inputDisabilitiesRate();
    },
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputDisabilitiesRate() {
      this.$emit("change-disabilities-rate-detail", {
        disabilitiesRate: this.disabilitiesRate,
        month: this.month,
        num: this.num,
      });
    },
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },

  }
}

</script>
